import { QUERY_STRING_PREFILL } from '../actions/queryStringPrefill'
import pad from '../helpers/pad'
import moment, { stringifyDate } from '../helpers/momentUtils'
import { updateSearchDetails } from '../actions/searchDetails'
import { updateParty } from '../actions/groupDetails'
import { requestAirportRoutes } from '../actions/airportRoutes'

const queryStringPrefill = store => next => action => {
  next(action)

  if (action.type !== QUERY_STRING_PREFILL) {
    return
  }
  const dispatch = store.dispatch
  const { params, airports } = action.data
  const {
    ds: outboundAirport,
    as: inboundAirport,
    od: outboundDay,
    om: outboundMonth,
    oy: outboundYear,
    id: inboundDay,
    im: inboundMonth,
    iy: inboundYear,
    ap: adults,
    cp: children,
    ip: babies,
  } = params
  const { searchDetails, groupDetails } = store.getState()
  const partyValues = { adults, children, babies }
  const updatedSearchDetails = {
    ...searchDetails,
    primary: {
      ...searchDetails.primary,
    },
  }
  const updatedParty = [...groupDetails.party].map(x => ({
    ...x,
    value: parseInt(partyValues[x.key], 10) || 0,
  }))
  if (outboundAirport) {
    const selectedAirport = airports.list.find(
      airport => airport.key === outboundAirport
    )
    dispatch(requestAirportRoutes(selectedAirport, 'outbound', 'primary'))
  }

  if (inboundAirport) {
    const selectedAirport = airports.list.find(
      airport => airport.key === inboundAirport
    )
    dispatch(requestAirportRoutes(selectedAirport, 'inbound', 'primary'))
  }

  if (outboundDay && outboundMonth && outboundYear) {
    const selectedOutboundDate = stringifyDate(
      moment(
        `${outboundYear}${pad(outboundMonth, 2)}${pad(outboundDay, 2)}`,
        'YYYY MM DD'
      )
    )
    updatedSearchDetails.selectedOutboundDate = selectedOutboundDate
  }

  if (inboundDay && inboundMonth && inboundYear) {
    const selectedInboundDate = stringifyDate(
      moment(
        `${inboundYear}${pad(inboundMonth, 2)}${pad(inboundDay, 2)}`,
        'YYYY MM DD'
      )
    )
    updatedSearchDetails.selectedInboundDate = selectedInboundDate
  }

  if (inboundYear === '1') {
    updatedSearchDetails.isSingleFlight = true
    // Set an inbound date in case the user switches back to a return flight
    updatedSearchDetails.selectedInboundDate = stringifyDate(
      moment(updatedSearchDetails.selectedOutboundDate, 'DD MMM YYYY').add(
        7,
        'days'
      )
    )
  }

  dispatch(updateParty(updatedParty))
  dispatch(updateSearchDetails(updatedSearchDetails))
}

export { queryStringPrefill }
